import React from 'react';
import classnames from 'classnames';
import Wix from '../../commons/services/Wix';
import request from '../../commons/services/request';
import getTranslation from '../../commons/translations';
import OpeningHoursTable from '../../commons/components/OpeningHoursTable';
import createStylesContainer
  from '../../commons/components/createStylesContainer';
import './Modal.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };
  }

  componentDidMount() {
    const type = Wix.Utils.getViewMode() === 'site' ? 'public' : 'draft';

    request.get(`/api/settings/${type}`).then(({ data }) => {
      this.setState(() => ({
        data
      }));
    });
  }

  render() {
    const { styles } = this.props;
    const { data } = this.state;

    if (!data) {
      return null;
    }

    const {
      openingHoursByDay,
      specialOpeningHours,
      tableHeadline
    } = data;

    const lang = styles.language.value;
    const translation = getTranslation(lang);
    const deviceType = Wix.Utils.getDeviceType();

    return (
      <div className={classnames('Modal', `Modal--${deviceType}`)}>
        <OpeningHoursTable
          headline={tableHeadline}
          openingHoursByDay={openingHoursByDay}
          specialOpeningHours={specialOpeningHours}
          styles={styles}
          translation={translation}
        />
      </div>
    );
  }
}

export default createStylesContainer(Modal);



// WEBPACK FOOTER //
// ./src/apps/modal/Modal.jsx